import { Flex, Spin } from 'antd';
import styles from './invite.module.scss';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { router } from '@app/providers/router/router-provider';
import { Routes } from '@shared/constants/routes';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';
import { useJoinTeamByToken } from '@shared/hooks/use-join-to-team-by-token';

export const InvitePage = () => {
  const { token } = useParams();
  const isAuthorized = useAppSelector(authSelectors.selectIsAuthorized);
  const { joinTeamByToken } = useJoinTeamByToken();

  useEffect(() => {
    if (isAuthorized && token) {
      const handleJoin = async () => {
        try {
          await joinTeamByToken(token);
          localStorage.removeItem('pendingInviteToken');
          router.navigate(Routes.analytics.root);
        } catch (error) {
          console.error(error);
          router.navigate(Routes.analytics.root);
        }
      };

      const timer = setTimeout(() => {
        if (isAuthorized && token) {
          handleJoin();
        }
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [isAuthorized, token, joinTeamByToken]);

  return (
    <Flex justify="center" align="center" className={styles.root}>
      <Spin size="large" />
    </Flex>
  );
};
